/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */

import React, { useState, useEffect, useRef, useContext } from 'react'
import format from 'date-fns/format'
import Modal from 'react-bootstrap/Modal'
import { useLocation } from '@reach/router'
import { Highlight } from '@zekro/react-highlight'
import InfiniteCalendar, {
  Calendar,
  withRange
} from '@tech_ett/react-infinite-calendar'
import { debounce } from 'throttle-debounce'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import clsx from 'clsx'

import useFlightBookForm from '../hooks/useFlightBookForm'
import useWindowSize from '../hooks/useWindowSize'
import AutoSuggestAirport from './autoSuggestAirport'
import validate from '../utils/formOneTwoValidation'
import ErrorModal from './errorModal'
import ErrorModalPassenger from './errorModalPassenger'
import CrossTopIcon from '../images/cross_top.svg'
import FromIcon from '../images/from-icon.jpg'
import ErrorIcon from '../images/error.svg'
import LocationIcon from '../images/location.jpg'
import ExchangeIcon from '../images/exchange.png'
import CalendarIcon from '../images/calendar.jpg'
import TravelerIcon from '../images/traveler.jpg'
import SearchIcon from '../images/btn-search.png'
import SmallCloseIcon from '../images/small-close-icon.svg'
import AirplaneTakeoffIcon from '../images/airplane-takeoff.inline.svg'
import AirplaneLandingIcon from '../images/airplane-landing.inline.svg'
import CalendarLargeIcon from '../images/calendar-large.inline.svg'
import TravelerLargeIcon from '../images/traveler-large.inline.svg'
import {
  CHILDREN_ERROR,
  DEFAULT_DATE_FORMAT,
  INFANT_LAP_ERROR,
  INFANT_SEAT_ERROR,
  ORIGIN_DEST_SAME_ERROR,
  PASSENGER_LIMIT_ERROR,
  ZERO_PASSENGER_ERROR
} from '../constants'
import { SEARCH_FLIGHTS } from '../routes'
import {
  FlightDataDispatchContext,
  FlightDataStateContext
} from '../contexts/flightData'
import { ReviewBannerDispatchContext } from '../contexts/reviewBannerContext'
// import UrlParamsContext from '../contexts/urlParams'

const airportCodeStyle = { fontSize: '20px', marginRight: '5px' }
let fakeInput = null

const FormOne = props => {
  const { windowHeight } = useWindowSize()
  const { search } = useLocation()
  const flightData = useContext(FlightDataStateContext)
  const setFlightData = useContext(FlightDataDispatchContext)
  // const urlParams = useContext(UrlParamsContext)
  const setShowReviewBanner = useContext(ReviewBannerDispatchContext)
  const [errors, setErrors] = useState({
    origin: '',
    destination: '',
    depDate: '',
    retDate: '',
    notSame: '',
    bothDatesRequired: ''
  })
  const [urlParams, setUrlParams] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [modalShow, setModalShow] = useState(false)
  const [modalContent, setModalContent] = useState({
    origin: false,
    destination: false,
    originDest: false,
    datepicker: false,
    childInfant: false
  })
  const [lastClickedDate, setLastClickedDate] = useState('depart')
  const [isSelected, setisSelected] = useState(0)

  const [isErrorModal, setIsErrorModal] = useState(false)
  const [isPassengerErrorModal, setIsPassengerErrorModal] = useState(false)
  const [isPassengerErrors, setIsPassengerErrors] = useState({
    passnegerCount: '',
    infantLap: '',
    infantSeat: '',
    zeroPassenger: '',
    children: ''
  })
  const [suggestions, setSuggestions] = useState([])
  const [morethan9, setMoreThan9] = useState(false)
  const [clearInput, setClearInput] = useState(null)
  const [loadingSuggestions, setLoadingSuggestions] = useState(false)
  const { inputs, handleInputChange, setInputs } = useFlightBookForm(setMoreThan9)
  const isTripRound = flightData.tripType === 'RT';
  const [senCheckTrip, setsenCheckTrip] = useState(false)
  const originInputRef = useRef()
  const destInputRef = useRef()
  const modalRef = useRef()

  useEffect(() => {
    if (flightData.tripType === 'RT')
      setsenCheckTrip(true)
    else
      setsenCheckTrip(false)
  })

  useEffect(() => {
    const searchParamsObj = {}
    const urlSearchParams = new URLSearchParams(search)
    for (const [key, value] of urlSearchParams.entries()) {
      searchParamsObj[key] = value
    }
    setUrlParams(searchParamsObj)
  }, []);

  const filteredSuggestions = suggestions.filter(e => !e.initial)
  const currentInputId = modalContent.origin
    ? 'origin'
    : modalContent.destination
      ? 'destination'
      : ''
  const currentFromToInputValue =
    (modalContent.origin &&
      originInputRef.current &&
      originInputRef.current.value) ||
    (modalContent.destination &&
      destInputRef.current &&
      destInputRef.current.value) ||
    ''
  inputs.firstLoad = props.isInitialMount.current
  const passengerCoach =
    inputs.cabin === 'e'
      ? 'Economy Class'
      : inputs.cabin === 'b'
        ? 'Business Class'
        : inputs.cabin === 'w'
          ? 'Premium Coach'
          : 'First Class'
  const passengersCount =
    inputs.travelers +
    inputs.travelerschd +
    inputs.travelerssnr +
    inputs.travelersinfSeat
  const passengerDetails =
    passengersCount > 1
      ? ' Travelers / ' + passengerCoach
      : ' Traveler / ' + passengerCoach

  useEffect(() => {
    if (
      errors.notSame ||
      errors.depDate ||
      errors.retDate ||
      (errors.bothDatesRequired &&
        flightData.origin !== '' &&
        flightData.destination !== '')
    ) {
      setIsErrorModal(true)
    } else {
      setIsErrorModal(false)
    }
    return () => {
      setIsErrorModal(false)
    }
  }, [errors])

  useEffect(() => {
    if (isSelected === 1) {
      if (originInputRef.current) {
        originInputRef.current.focus()
      }
      disableBodyScroll(modalRef.current)
    } else if (isSelected === 2) {
      if (destInputRef.current) {
        destInputRef.current.focus()
      }
      disableBodyScroll(modalRef.current)
    }

    if (fakeInput) {
      fakeInput.remove()
      fakeInput = null
    }
  }, [isSelected])

  useEffect(() => {
    if (
      morethan9 &&
      isPassengerErrors.passnegerCount !== '' &&
      isPassengerErrors.infantLap !== '' &&
      isPassengerErrors.infantSeat !== ''
    ) {
      setIsPassengerErrors({
        passnegerCount: PASSENGER_LIMIT_ERROR
      })

      setIsPassengerErrorModal(true)
      setMoreThan9(false)
    }
  }, [morethan9])

  useEffect(() => {
    if (flightData.depDate && flightData.retDate) {
      setErrors({ bothDatesRequired: '' })
    }
    if (flightData.depDate) {
      setErrors({ depDate: '' })
    }
    if (flightData.retDate) {
      setErrors({ retDate: '' })
    }
  }, [flightData.depDate, flightData.retDate])

  useEffect(() => {
    checkPassengerError()
    return () => {
      setIsPassengerErrorModal(false)
      setIsPassengerErrors({})
    }
  }, [passengersCount])

  useEffect(() => {
    if (modalShow) document.documentElement.style.height = '100vh'
    else document.documentElement.style.height = ''
  }, [modalShow])

  useEffect(() => {
    if (urlParams && urlParams.travelers) {
      setInputs(prevState => ({
        ...prevState,
        travelers: parseInt(urlParams.travelers)
      }));
      window.sessionStorage.setItem('travelers', parseInt(urlParams.travelers));
    }

    if (urlParams && urlParams.travelerschd) {
      setInputs(prevState => ({
        ...prevState,
        travelerschd: parseInt(urlParams.travelerschd),
      }));
      window.sessionStorage.setItem('travelerschd', parseInt(urlParams.travelerschd));
    }

    if (urlParams && urlParams.travelersinf) {
      setInputs(prevState => ({
        ...prevState,
        travelersinfSeat: parseInt(urlParams.travelersinf),
      }));
      window.sessionStorage.setItem('travelersinfSeat', parseInt(urlParams.travelersinf));
    }

    if (urlParams && urlParams.cabin) {
      setInputs(prevState => ({
        ...prevState,
        cabin: urlParams.cabin.toLowerCase(),
      }));
      window.sessionStorage.setItem('cabin', urlParams.cabin.toLowerCase());
    }
  }, [urlParams]);

  const showRoundTripForm = () => {
    setFlightData(prevState => ({
      ...prevState,
      tripType: 'RT'
    }))
  }

  const showOneWayForm = () => {
    setFlightData(prevState => ({
      ...prevState,
      tripType: 'OW'
    }))
  }

  const exchangeDetails = () => {
    window.sessionStorage.removeItem('originCode');
    setFlightData(prevState => ({
      ...prevState,
      origin: prevState.destination && prevState.destination,
      destination: prevState.origin,
      originCode: prevState.destCode,
      destCode: prevState.originCode,
      originCity: prevState.destCity,
      destCity: prevState.originCity,
      originRegion: prevState.destRegion,
      destRegion: prevState.originRegion
    }));
    props.setExchangeData(true)
  }

  const updateFlightData = (
    fetchId,
    suggestion,
    sugAirport,
    cityName,
    tripVal
  ) => {
    if (!suggestion.includes('undefined')) {
      if (fetchId === 'origin') {
        setFlightData(prevState => ({
          ...prevState,
          origin: suggestion,
          originCode: sugAirport,
          tripType: tripVal,
          originCity: cityName
        }))
      }

      if (fetchId === 'destination')
        setFlightData(prevState => ({
          ...prevState,
          destination: suggestion,
          destCode: sugAirport,
          tripType: tripVal,
          destCity: cityName
        }))
    }
  }

  const setFromToDate = (dept, ret, days) => {
    setFlightData(prevState => ({
      ...prevState,
      depDate: dept,
      retDate: ret,
      daysTrip: days ? days : 0
    }))
  }

  const handleSubmit = event => {
    event.preventDefault()

    const formErrors = validate(flightData, isTripRound)
    setErrors(formErrors)

    if (!Object.keys(formErrors).length && !checkPassengerError()) {
      setIsSubmitting(true)
      flightBook()
    }
  }

  const handleOriginInputFocus = () => openOriginDestPopup('origin')

  const handleDestInputFocus = () => openOriginDestPopup('destination')

  const fetchOrDes = (fetchId = currentInputId) => {
    updateFlightData(fetchId, '', '', '', isTripRound == true ? 'RT' : 'OW')
  }

  const flightBook = () => {
    const queryParams = new URLSearchParams({
      oneway: isTripRound == true ? 'n' : 'y',
      origin: flightData.origin,
      origincode: flightData.originCode.trim(),
      originregioncode: flightData.originRegion || inputs.originregioncode,
      destination: flightData.destination,
      destcode: flightData.destCode.trim(),
      destregioncode: flightData.destRegion || inputs.destregioncode,
      dep_date: format(flightData.depDate, DEFAULT_DATE_FORMAT),
      depart_time: inputs.depart_time,
      ret_date: format(flightData.retDate, DEFAULT_DATE_FORMAT),
      return_time: inputs.return_time,
      travelers: inputs.travelers,
      travelerssnr: inputs.travelerssnr,
      travelerschd: inputs.travelerschd + inputs.travelersinfSeat,
      travelersinf: inputs.travelersinfLap,
      cabin: inputs.cabin,
      try_search: inputs.try_search,
      ref: urlParams.ref || inputs.ref,
      past_book: parseInt(window.localStorage.booked) === 1 ? 1 : 0
    })

    if (urlParams.utm_medium || urlParams.medium)
      queryParams.append('utm_medium', urlParams.utm_medium || urlParams.medium)
    if (urlParams.utm_source || urlParams.source)
      queryParams.append('utm_source', urlParams.utm_source || urlParams.source)
    if (urlParams.utm_content || urlParams.content)
      queryParams.append('utm_content', urlParams.utm_content || urlParams.content)
    if (urlParams.utm_campaign || urlParams.campaign)
      queryParams.append('utm_campaign', urlParams.utm_campaign || urlParams.campaign)
    if (urlParams.utm_term || urlParams.term)
      queryParams.append('utm_term', urlParams.utm_term || urlParams.term)
    if (urlParams.affiliate_id)
      queryParams.append('affiliate_id', urlParams.affiliate_id)
    if (urlParams.affiliate_sub_id)
      queryParams.append('affiliate_sub_id', urlParams.affiliate_sub_id)
    queryParams.append('m_site', 1)
    const searchFlightsUrl = new URL(
      SEARCH_FLIGHTS + '?' + queryParams.toString()
    )

    // Listening to pageHide event to reset isSubmitting state
    const pageHideCallback = () => {
      setIsSubmitting(false)
      setShowReviewBanner(false)
      window.removeEventListener('pagehide', pageHideCallback)
    }
    window.addEventListener('pagehide', pageHideCallback, false)

    window.location.href = searchFlightsUrl
  }

  const checkPassengerError = () => {
    if (passengersCount <= 0) {
      setIsPassengerErrors({
        zeroPassenger: ZERO_PASSENGER_ERROR
      })
      if (
        flightData.origin &&
        flightData.destination &&
        flightData.retDate &&
        flightData.depDate
      )
        setIsPassengerErrorModal(true)
      if (modalContent.childInfant) setIsPassengerErrorModal(true)
      return true
    } else if (
      passengersCount <= 9 &&
      inputs.travelers + inputs.travelerssnr < inputs.travelersinfLap
    ) {
      setIsPassengerErrors({
        infantLap: INFANT_LAP_ERROR
      })
      setIsPassengerErrorModal(true)
      return true
    } else if (
      passengersCount <= 9 &&
      inputs.travelers >= 0 &&
      (inputs.travelers + inputs.travelerssnr) * 2 <
      inputs.travelersinfSeat + inputs.travelersinfLap
    ) {
      setIsPassengerErrors({
        infantSeat: INFANT_SEAT_ERROR
      })
      setIsPassengerErrorModal(true)
      return true
    } else if (
      inputs.travelerschd &&
      !(inputs.travelers + inputs.travelerssnr)
    ) {
      setIsPassengerErrors({
        children: CHILDREN_ERROR
      })
      setIsPassengerErrorModal(true)
      return true
    }
    return false
  }

  const handleHide = () => {
    setModalShow(false)
    setisSelected(null)
    setShowReviewBanner(true)
    clearAllBodyScrollLocks()
  }

  const focusFakeInput = () => {
    // https://stackoverflow.com/a/55652503
    // create invisible dummy input to receive the focus first
    fakeInput = document.createElement('input')
    fakeInput.setAttribute('type', 'text')
    fakeInput.style.position = 'absolute'
    fakeInput.style.opacity = 0
    fakeInput.style.height = 0
    fakeInput.style.fontSize = '16px' // disable auto zoom

    document.body.prepend(fakeInput)
    fakeInput.focus()
  }

  function openOriginDestPopup(popupView, event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (popupView === 'origin') {
      focusFakeInput()
      setisSelected(1)
      setModalContent({
        origin: true,
        destination: false,
        originDest: true,
        datepicker: false,
        childInfant: false
      })
    } else if (popupView === 'destination') {
      focusFakeInput()
      setisSelected(2)
      setModalContent({
        origin: false,
        destination: true,
        originDest: true,
        datepicker: false,
        childInfant: false
      })
    } else if (popupView === 'datePickerDepart') {
      setisSelected(3)
      setLastClickedDate('depart')
      setModalContent({
        origin: false,
        destination: false,
        originDest: false,
        datepicker: true,
        childInfant: false
      })
      clearAllBodyScrollLocks()
    } else if (popupView === 'datePickerReturn') {
      setisSelected(4)
      setLastClickedDate('return')
      setModalContent({
        origin: false,
        destination: false,
        originDest: false,
        datepicker: true,
        childInfant: false
      })
      clearAllBodyScrollLocks()
    } else if (popupView === 'passenger') {
      setisSelected(5)
      setModalContent({
        origin: false,
        destination: false,
        originDest: false,
        datepicker: false,
        childInfant: true
      })
      clearAllBodyScrollLocks()
    }

    setModalShow(true)
  }

  function onSuggestionSelected(id) {
    if (id === 'origin') {
      openOriginDestPopup('destination')
    } else if (id === 'destination') {
      openOriginDestPopup('datePickerDepart')
    }
  }

  const hideErrorModal = () => {
    setIsErrorModal(false)
  }

  const getDatesDifference = (dat1, dat2) => {
    let date1 = new Date(dat1)
    let date2 = new Date(dat2)
    const differenceInTime = date2.getTime() - date1.getTime()
    return differenceInTime / (1000 * 3600 * 24)
  }

  const handleDateSelect = selected => {
    selected.start = format(selected.start, DEFAULT_DATE_FORMAT)
    selected.end = format(selected.end, DEFAULT_DATE_FORMAT)
    if (!isTripRound) {
      setFromToDate(selected.start, '', 0)
    } else {
      if (lastClickedDate === 'depart') {
        if (flightData.retDate) {
          setisSelected(4)
          setFromToDate(
            selected.start,
            (new Date(selected.start) - new Date(flightData.retDate) > 0) ? '' : flightData.retDate,
            Math.abs(getDatesDifference(selected.start, flightData.retDate))
          )
        } else {
          setisSelected(4)
          setFromToDate(
            selected.start,
            flightData.retDate,
            Math.abs(getDatesDifference(selected.end, flightData.retDate))
          )
        }
        setLastClickedDate('return')
      } else {
        if (flightData.depDate === '') {
          setLastClickedDate('depart')
          setisSelected(3)
          setFromToDate(
            flightData.depDate,
            selected.end,
            Math.abs(getDatesDifference(selected.end, flightData.depDate))
          )
        } else if (new Date(selected.end) >= new Date(flightData.depDate)) {
          setFromToDate(
            flightData.depDate,
            selected.end,
            Math.abs(getDatesDifference(selected.end, flightData.depDate))
          )
        }
      }
    }
  }

  const renderSuggestion = suggestion => {
    const query = modalContent.origin
      ? originInputRef.current
        ? originInputRef.current.value
        : ''
      : destInputRef.current
        ? destInputRef.current.value
        : ''

    return (
      <div className='result'>
        <div
          className={suggestion.airportCode ? 'col-xs-2' : ''}
          style={airportCodeStyle}
        >
          <Highlight
            keywords={[query]}
            content={suggestion.airportCode ? suggestion.airportCode : ''}
          />
          {suggestion.airportCode ? ' ' : ''}
        </div>
        <div
          className={clsx(
            'resultRight',
            suggestion.airportCode ? 'col-xs-10' : 'col-xs-12'
          )}
        >
          <Highlight
            keywords={[query]}
            content={
              suggestion.airportCode
                ? (suggestion.airportName
                  ? suggestion.airportName.length > 30
                    ? suggestion.airportName.substring(0, 28) + ' ...'
                    : suggestion.airportName
                  : '') +
                (suggestion.airportName ? '\n' : '') +
                (suggestion.airportCode ? suggestion.cityName + ', ' : '') +
                suggestion.countryName
                : 'Unable to find airport/city'
            }
          />
        </div>
      </div>
    )
  }

  const handleSuggestionClick = suggestion => {
    const suggestionValue = getSuggestionValue(suggestion)
    if (suggestionValue) {
      const { origin, destination } = flightData
      const tripCode = isTripRound == true ? 'RT' : 'OW'
      if (
        (currentInputId === 'origin' && destination === suggestionValue) ||
        (currentInputId === 'destination' && origin === suggestionValue)
      ) {
        setSuggestions([])
        setClearInput(currentInputId)
        setErrors({
          notSame: ORIGIN_DEST_SAME_ERROR
        })
        updateFlightData(currentInputId, '', '', '', tripCode)
      } else {
        updateFlightData(
          currentInputId,
          suggestionValue,
          suggestion.airportCode,
          suggestion.cityName,
          tripCode
        )
        openOriginDestPopup(
          modalContent.origin ? 'destination' : 'datePickerDepart'
        )
      }
    }
  }

  const getSuggestionValue = suggestion => {
    if (suggestion && (suggestion !== undefined || suggestion !== '')) {
      return `${suggestion.airportCode} - ${suggestion.cityName}, ${suggestion.countryName}`
    }
    return ''
  }

  const handlePopupScroll = () => {
    if (modalContent.origin) {
      originInputRef && originInputRef.current.blur()
    } else if (modalContent.destination) {
      destInputRef && destInputRef.current.blur()
    }
  }

  const handlePopupScrollDebounced = debounce(100, true, handlePopupScroll)

  const handleRecentSearchClear = e => {
    e.preventDefault()
    e.stopPropagation()

    if (isSelected === 1 && originInputRef.current) {
      originInputRef.current.focus()
    } else if (isSelected === 2 && destInputRef.current) {
      destInputRef.current.focus()
    }

    setSuggestions([])
    fetchOrDes()
  }

  const handleInfantPassengerDetails = event => {
    const { id } = event.target

    let {
      travelers,
      travelerschd,
      travelerssnr,
      travelersinfLap,
      travelersinfSeat
    } = inputs

    if (id === 'infantLapMobPlus') travelersinfLap++
    else if (id === 'infantSeatMobPlus') travelersinfSeat++
    else if (id === 'childMobPlus') travelerschd++

    if (travelers + travelerssnr < travelersinfLap) {
      setIsPassengerErrors({
        infantLap: INFANT_LAP_ERROR
      })
      setIsPassengerErrorModal(true)
    } else if (
      (travelers + travelerssnr) * 2 <
      travelersinfSeat + travelersinfLap
    ) {
      setIsPassengerErrors({
        infantSeat: INFANT_SEAT_ERROR
      })
      setIsPassengerErrorModal(true)
    } else if (travelerschd && !(travelers + travelerssnr)) {
      setIsPassengerErrors({
        children: CHILDREN_ERROR
      })
      setIsPassengerErrorModal(true)
    } else {
      handleInputChange(event)
    }
  }

  return (
    <div className='bg-grey'>
      <ErrorModalPassenger
        show={isPassengerErrorModal}
        onHide={setIsPassengerErrorModal}
        errorMsg={isPassengerErrors}
      />
      <ErrorModal
        show={isErrorModal}
        onHide={hideErrorModal}
        errorMsg={errors}
      />
      <Modal
        id='myModal'
        show={modalShow}
        onHide={handleHide}
        animation={false}
        fullscreen
      >
        <Modal.Body
          className={modalContent['datepicker'] ? 'CalendarPaddingZero' : ''}
        >
          <div className='container'>
            <div className='row'>
              <div className='col-xs-12 pd-0'>
                <ul className='nav nav-tabs main_form_header'>
                  <li
                    style={{
                      borderBottom: modalContent['origin']
                        ? '3px solid #3a66ad'
                        : errors.origin
                          ? '3px solid red'
                          : flightData.origin
                            ? '3px solid green'
                            : 'none'
                    }}
                    onClick={e => openOriginDestPopup('origin', e)}
                  >
                    <a
                      data-toggle='tab'
                      title='Origin'
                      aria-expanded='false'
                      className={
                        !modalContent['origin']
                          ? flightData.origin
                            ? 'mark_completed'
                            : errors.origin
                              ? 'form_header_warning'
                              : ''
                          : ''
                      }
                    >
                      <span className='round-tabs two'>
                        <AirplaneTakeoffIcon
                          style={{
                            fill: modalContent['origin']
                              ? '#3a66ad'
                              : errors.origin
                                ? 'red'
                                : flightData.origin
                                  ? 'green'
                                  : ''
                          }}
                        />
                      </span>
                    </a>
                  </li>
                  <li
                    style={{
                      borderBottom: modalContent['destination']
                        ? '3px solid #3a66ad'
                        : errors.destination || errors.notSame
                          ? '3px solid red'
                          : flightData.destination
                            ? '3px solid green'
                            : 'none'
                    }}
                    onClick={e => openOriginDestPopup('destination', e)}
                  >
                    <a

                      data-toggle='tab'
                      title='Destination'
                      aria-expanded='false'
                      className={
                        !modalContent['destination']
                          ? flightData.destination
                            ? 'mark_completed'
                            : errors.destination || errors.notSame
                              ? 'form_header_warning'
                              : ''
                          : ''
                      }
                    >
                      <span className='round-tabs two'>
                        <AirplaneLandingIcon
                          style={{
                            fill: modalContent['destination']
                              ? '#3a66ad'
                              : errors.destination || errors.notSame
                                ? 'red'
                                : flightData.destination
                                  ? 'green'
                                  : ''
                          }}
                        />
                      </span>
                    </a>
                  </li>
                  <li
                    style={{
                      borderBottom: modalContent['datepicker']
                        ? '3px solid #3a66ad'
                        : (isTripRound && errors.retDate) ||
                          errors.depDate ||
                          errors.bothDatesRequired
                          ? '3px solid red'
                          : flightData.depDate === '' ||
                            (isTripRound && flightData.retDate === '')
                            ? 'none'
                            : '3px solid green'
                    }}
                    onClick={() => openOriginDestPopup('datePickerDepart')}
                  >
                    <a

                      data-toggle='tab'
                      title='Date'
                      aria-expanded='true'
                      className={
                        !modalContent['datepicker']
                          ? flightData.depDate &&
                            (!isTripRound ||
                              (isTripRound && flightData.retDate))
                            ? 'mark_completed'
                            : (isTripRound && errors.retDate) ||
                              errors.depDate ||
                              errors.bothDatesRequired
                              ? 'form_header_warning'
                              : ''
                          : ''
                      }
                    >
                      <span className='round-tabs two'>
                        <CalendarLargeIcon
                          style={{
                            fill: modalContent['datepicker']
                              ? '#3a66ad'
                              : (isTripRound && errors.retDate) ||
                                errors.depDate ||
                                errors.bothDatesRequired
                                ? 'red'
                                : flightData.depDate === '' ||
                                  (isTripRound && flightData.retDate === '')
                                  ? ''
                                  : 'green'
                          }}
                        />
                      </span>
                    </a>
                  </li>
                  <li
                    style={{
                      borderBottom: modalContent['childInfant']
                        ? '3px solid #3a66ad'
                        : passengersCount === 0
                          ? '3px solid red'
                          : passengersCount <= 1
                            ? 'none'
                            : '3px solid green'
                    }}
                    onClick={() => openOriginDestPopup('passenger')}
                  >
                    <a

                      data-toggle='tab'
                      title='Passenger Details'
                      aria-expanded='true'
                      className={
                        !modalContent['childInfant']
                          ? passengersCount > 1
                            ? 'mark_completed'
                            : passengersCount === 0
                              ? 'form_header_warning'
                              : ''
                          : ''
                      }
                    >
                      <span className='round-tabs two'>
                        <TravelerLargeIcon
                          style={{
                            fill: modalContent['childInfant']
                              ? '#3a66ad'
                              : passengersCount === 0
                                ? 'red'
                                : passengersCount <= 1
                                  ? ''
                                  : 'green'
                          }}
                        />
                      </span>
                    </a>
                  </li>
                  <li style={{ width: '12%' }}>
                    <div className='cross_top'>
                      <img src={CrossTopIcon} onClick={handleHide} alt='' />
                    </div>
                  </li>
                </ul>
                <div
                  className='tab-content'
                  style={{
                    overflowY: 'scroll',
                    height: `${windowHeight - 57}px`
                  }}
                  onScroll={handlePopupScrollDebounced}
                  ref={modalRef}
                >
                  {modalContent.originDest && (
                    <div className='tab-pane active in' id='depart'>
                      <div id='bookFlt'>
                        <div className='col-xs-12 no-bdr-r-mb'>
                          <div className='form-group' id='desk_from'>
                            <label
                              className='sa-leavingtxt-modal'
                              htmlFor='origin'
                            >
                              From
                            </label>
                            <div
                              role='combobox'
                              aria-haspopup='listbox'
                              aria-owns='react-autowhatever-origin'
                              aria-expanded='false'
                              className='react-autosuggest__container'
                            >
                              <AutoSuggestAirport
                                id='origin'
                                place='Enter City or Airport'
                                suggestions={suggestions}
                                setSuggestions={setSuggestions}
                                asHandler={fetchOrDes}
                                setErrors={setErrors}
                                errors={errors}
                                value={flightData.origin}
                                className={
                                  errors.origin
                                    ? `form-control selc_adj_org`
                                    : `form-control selc_adj_org`
                                }
                                flightData={flightData}
                                onSuggestionSelected={onSuggestionSelected}
                                onInputFocus={handleOriginInputFocus}
                                inputRef={originInputRef}
                                isFocused={modalContent.origin}
                                clearInput={clearInput}
                                setClearInput={setClearInput}
                                setLoadingSuggestions={setLoadingSuggestions}
                              />
                            </div>
                          </div>
                        </div>

                        <div className='col-xs-12 no-bdr-r-mb'>
                          <div
                            className='form-group dest_autosug_input'
                            id='desk_from'
                            style={{ marginTop: '10px' }}
                          >
                            <label
                              className='sa-leavingtxt-modal'
                              htmlFor='destination'
                            >
                              To

                            </label>
                            <div
                              role='combobox'
                              aria-haspopup='listbox'
                              aria-owns='react-autowhatever-origin'
                              aria-expanded='false'
                              className='react-autosuggest__container'
                            >
                              <AutoSuggestAirport
                                id='destination'
                                place='Enter City or Airport'
                                suggestions={suggestions}
                                setSuggestions={setSuggestions}
                                asHandler={fetchOrDes}
                                setErrors={setErrors}
                                errors={errors}
                                value={flightData.destination}
                                className={
                                  errors.destination
                                    ? `form-control selc_adj_org`
                                    : `form-control selc_adj_org`
                                }
                                flightData={flightData}
                                onSuggestionSelected={onSuggestionSelected}
                                onInputFocus={handleDestInputFocus}
                                inputRef={destInputRef}
                                isFocused={modalContent.destination}
                                clearInput={clearInput}
                                setClearInput={setClearInput}
                                setLoadingSuggestions={setLoadingSuggestions}
                              />
                            </div>
                          </div>
                        </div>
                        <div className='col-xs-12' style={{ padding: 0 }}>
                          <h6
                            style={{
                              margin: '10px 10px 0',
                              fontSize: '18px'
                            }}
                          >
                            {!!filteredSuggestions.length ? (
                              <>
                                Matching with "
                                <strong className='highlight-highlighted'>
                                  {currentFromToInputValue.toUpperCase()}
                                </strong>
                                "
                              </>
                            ) : loadingSuggestions ? (
                              `Searching...`
                            ) : (
                              (modalContent.origin && flightData.origin && (
                                <>
                                  Recent "
                                  <strong className='highlight-highlighted'>
                                    From
                                  </strong>
                                  " Search
                                </>
                              )) ||
                              (modalContent.destination &&
                                flightData.destination && (
                                  <>
                                    Recent "
                                    <strong className='highlight-highlighted'>
                                      To
                                    </strong>
                                    " Search
                                  </>
                                ))
                            )}
                          </h6>
                          <ul
                            className='react-autosuggest__suggestions-list'
                            style={{ border: 'none' }}
                          >
                            {!!suggestions.length &&
                              suggestions.map((suggestion, index) => (
                                <li
                                  key={`${suggestion.airportCode}-${index}`}
                                  id={`${suggestion.airportCode}-${index}`}
                                  className='react-autosuggest__suggestion'
                                  onClick={() =>
                                    handleSuggestionClick(suggestion)
                                  }
                                >
                                  {renderSuggestion(suggestion)}
                                </li>
                              ))}
                            {suggestions.some(e => e.initial) && (
                              <button
                                className='btn clear_recent_search_icon'
                                onClick={handleRecentSearchClear}
                              >
                                <img
                                  src={SmallCloseIcon}
                                  alt='Cross Sign'
                                  className='deptCrsSign'
                                />
                              </button>
                            )}
                          </ul>
                        </div>
                      </div>
                    </div>
                  )}

                  {modalContent.datepicker && (
                    <div className='tab-pane' id='date'>
                      <div id='bookFlt'>
                        <div
                          className='seletDate-Wrap'
                          data-target='#myModal'
                        >
                          <div
                            className={
                              lastClickedDate === 'depart'
                                ? 'departs__wrap date--active'
                                : 'departs__wrap'
                            }
                          >
                            <span className='f13'>Depart</span>
                            <span
                              className='selectDates-Txt departDate'
                              onClick={() =>
                                openOriginDestPopup('datePickerDepart')
                              }
                              style={{
                                marginBottom:
                                  !flightData.depDate && flightData.retDate
                                    ? '15px'
                                    : ''
                              }}
                            >
                              {flightData.depDate === '' ? (
                                <span>Select Date</span>
                              ) : (
                                <span>
                                  <span>
                                    <span className='is--d-inlineBlock f37 v-middle'>
                                      {format(flightData.depDate, 'DD')}
                                    </span>
                                    <span className='f11 is--d-inlineBlock v-top'>
                                      <span className='is--dblock month-txt'>
                                        {format(flightData.depDate, 'MMM')}
                                      </span>
                                      <span className='is--dblock'>
                                        {format(flightData.depDate, 'ddd')}
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              )}
                            </span>
                          </div>
                          {!isTripRound && (
                            <div
                              className={'departs__wrap'}
                              style={{
                                borderLeft: '1px solid #1655b6',
                                color: '#1655b6'
                              }}
                              onClick={() => {
                                showRoundTripForm()
                                setFromToDate(flightData.depDate, '', 0)
                                openOriginDestPopup('datePickerReturn')
                              }}
                            >
                              <p style={{ margin: '6px -5px 5px 10px' }}>
                                Choose return date for more savings!
                              </p>
                            </div>
                          )}

                          {isTripRound && (
                            <div
                              className={
                                lastClickedDate === 'return'
                                  ? 'departs__wrap date--active'
                                  : 'departs__wrap'
                              }
                            >
                              <span className='f13'>Return</span>
                              <span
                                className='selectDates-Txt returnDate'
                                onClick={() =>
                                  openOriginDestPopup('datePickerReturn')
                                }
                                style={{
                                  marginBottom:
                                    flightData.depDate && !flightData.retDate
                                      ? '15px'
                                      : ''
                                }}
                              >
                                {flightData.retDate === '' ? (
                                  <span>Select Date</span>
                                ) : (
                                  <span>
                                    <span>
                                      <span className='is--d-inlineBlock f37 v-middle'>
                                        {format(flightData.retDate, 'DD')}
                                      </span>
                                      <span className='f11 is--d-inlineBlock v-top'>
                                        <span className='is--dblock month-txt'>
                                          {format(flightData.retDate, 'MMM')}
                                        </span>
                                        <span className='is--dblock'>
                                          {format(flightData.retDate, 'ddd')}
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                )}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      <InfiniteCalendar
                        displayOptions={{
                          showHeader: false
                        }}
                        focusOn={lastClickedDate}
                        Component={withRange(Calendar)}
                        width={'100%'}
                        height={
                          windowHeight -
                          (flightData.retDate || flightData.depDate ? 246 : 231)
                        }
                        min={new Date()}
                        max={
                          new Date(
                            new Date().setDate(new Date().getDate() + 330)
                          )
                        }
                        minDate={
                          isTripRound && isSelected !== 3 && flightData.depDate
                            ? new Date(flightData.depDate)
                            : new Date()
                        }
                        maxDate={
                          new Date(
                            new Date().setDate(new Date().getDate() + 330)
                          )
                        }
                        selected={{
                          start: isTripRound
                            ? !flightData.depDate
                              ? flightData.retDate
                              : flightData.depDate
                            : flightData.depDate,
                          end: isTripRound
                            ? flightData.retDate
                              ? flightData.retDate
                              : flightData.depDate
                            : flightData.depDate
                        }}
                        onSelect={handleDateSelect}
                      />
                      <div
                        className='travelerBtn-section row'
                        style={{ backgroundColor: '#fff' }}
                      >
                        <button
                          id='resetAllDates'
                          className={
                            flightData.depDate === '' &&
                              flightData.retDate === ''
                              ? 'btn-reset disabledResetButton'
                              : 'btn-reset'
                          }
                          onClick={() => setFromToDate('', '', 0)}
                          disabled={
                            flightData.depDate === '' &&
                              flightData.retDate === ''
                              ? 'disabled'
                              : ''
                          }
                        >
                          Clear Dates
                        </button>
                        <button
                          className='donetraveler-btn btn-color'
                          onClick={() => openOriginDestPopup('passenger')}
                        >
                          Confirm Dates
                        </button>
                      </div>
                    </div>
                  )}
                  {modalContent.childInfant && (
                    <div className='tab-pane' id='traveler'>
                      <div id='bookFlt'>
                        <main role='main' className='main-contents  is--dblock'>
                          <section className='widget-section--new '>
                            <div className='widget'>
                              <div className='traveler-wrap--new '>
                                <div className='traveler-wrap--new_scroll'>
                                  <div className='row'>
                                    <ul className='traveler-list--new'>
                                      <li>
                                        <span className='control-label'>
                                          <span className='adultstr'>
                                            {Number(inputs.travelers) !== 1
                                              ? 'Adults'
                                              : 'Adult'}
                                            <span className='age-brackets f12'>
                                              <br />
                                              <span className='f11 traveler-msg_gray'>
                                                11 - 65 years old
                                              </span>
                                              <span className='is--dblock child__over'></span>
                                            </span>
                                          </span>
                                        </span>
                                        <div className='toggle is--textCenter is--right'>
                                          <span
                                            id='travelersMobMinus'
                                            name='travelers'
                                            value={inputs.travelers}
                                            className={
                                              inputs.travelers > 0
                                                ? 'is--left plus-minus--gray disable-btn minPax is--blue primaryBorder--color'
                                                : 'is--left plus-minus--gray disable-btn minPax '
                                            }
                                            onClick={handleInputChange}
                                          >
                                            -
                                          </span>
                                          <span
                                            id='travelersMobPlus'
                                            className='pasCount is--blue'
                                          >
                                            {inputs.travelers}
                                          </span>
                                          <span
                                            id='travelersMobPlus'
                                            name='travelers'
                                            value={inputs.travelers}
                                            className={
                                              inputs.travelers < 9
                                                ? 'is--left plus-minus--gray disable-btn maxPax is--blue primaryBorder--color'
                                                : 'is--left plus-minus--gray disable-btn maxPax'
                                            }
                                            onClick={handleInputChange}
                                          >
                                            +
                                          </span>
                                        </div>
                                      </li>
                                      <li>
                                        <span className='control-label '>
                                          <span className='adultstr'>
                                            {inputs.travelerschd !== 1
                                              ? 'Children'
                                              : 'Child'}
                                            <span className='age-brackets f12'>
                                              <br />
                                              <span className='f11 traveler-msg_gray'>
                                                2 - 11 years old
                                              </span>
                                              <span className='is--dblock child__over'></span>
                                            </span>
                                          </span>
                                        </span>
                                        <div className='toggle is--textCenter is--right'>
                                          <span
                                            id='childMobMinus'
                                            name='travelerschd'
                                            value={inputs.travelerschd}
                                            className={
                                              inputs.travelerschd <= 0
                                                ? 'is--left plus-minus--gray disable-btn minPax '
                                                : 'is--left plus-minus--gray disable-btn maxPax is--blue primaryBorder--color'
                                            }
                                            onClick={handleInputChange}
                                          >
                                            -
                                          </span>
                                          <span className='pasCount is--blue'>
                                            {inputs.travelerschd}
                                          </span>
                                          <span
                                            id='childMobPlus'
                                            name='travelerschd'
                                            value={inputs.travelerschd}
                                            className={
                                              inputs.travelerschd < 8
                                                ? 'is--left plus-minus--gray disable-btn maxPax  is--blue primaryBorder--color'
                                                : 'is--left plus-minus--gray disable-btn maxPax'
                                            }
                                            onClick={handleInputChange}
                                          >
                                            +
                                          </span>
                                        </div>
                                      </li>
                                      <li>
                                        <span className='control-label '>
                                          <span className='adultstr'>
                                            {inputs.travelerssnr !== 1
                                              ? 'Seniors'
                                              : 'Senior'}
                                            <br />
                                            <span className='f11 traveler-msg_gray'>
                                              65+ years old
                                            </span>
                                          </span>
                                        </span>
                                        <div className='toggle is--textCenter is--right'>
                                          <span
                                            id='seniourMobMinus'
                                            name='travelerssnr'
                                            value={inputs.travelerssnr}
                                            className={
                                              inputs.travelerssnr <= 0
                                                ? 'is--left plus-minus--gray disable-btn minPax '
                                                : 'is--left plus-minus--gray disable-btn maxPax is--blue primaryBorder--color'
                                            }
                                            onClick={handleInputChange}
                                          >
                                            -
                                          </span>
                                          <span className='pasCount is--blue'>
                                            {inputs.travelerssnr}
                                          </span>
                                          <span
                                            id='seniourMobPlus'
                                            name='travelerssnr'
                                            value={inputs.travelerssnr}
                                            className={
                                              inputs.travelerssnr < 9
                                                ? 'is--left plus-minus--gray disable-btn maxPax is--blue primaryBorder--color'
                                                : 'is--left plus-minus--gray disable-btn maxPax'
                                            }
                                            onClick={handleInputChange}
                                          >
                                            +
                                          </span>
                                        </div>
                                      </li>
                                      <li>
                                        <span className='control-label '>
                                          <span className='adultstr infantOnSeat'>
                                            {inputs.travelersinfSeat !== 1
                                              ? 'Infants on Seat'
                                              : 'Infant on Seat'}
                                            <br />
                                            <span className='f11 traveler-msg_gray underTwoYrOld'>
                                              Under 2 years old
                                            </span>
                                          </span>
                                        </span>
                                        <div className='toggle is--textCenter is--right'>
                                          <span
                                            id='infantSeatMobMinus'
                                            name='travelersinfSeat'
                                            value={inputs.travelersinfSeat}
                                            className={
                                              inputs.travelersinfSeat <= 0
                                                ? 'is--left plus-minus--gray disable-btn minPax '
                                                : 'is--left plus-minus--gray disable-btn maxPax is--blue primaryBorder--color'
                                            }
                                            onClick={handleInputChange}
                                          >
                                            -
                                          </span>
                                          <span className='pasCount is--blue'>
                                            {inputs.travelersinfSeat}
                                          </span>
                                          <span
                                            id='infantSeatMobPlus'
                                            name='travelersinfSeat'
                                            value={inputs.travelersinfSeat}
                                            className={
                                              inputs.travelersinfSeat < 8
                                                ? 'is--left plus-minus--gray disable-btn maxPax is--blue primaryBorder--color'
                                                : 'is--left plus-minus--gray disable-btn maxPax'
                                            }
                                            onClick={
                                              handleInfantPassengerDetails
                                            }
                                          >
                                            +
                                          </span>
                                        </div>
                                      </li>
                                      <li>
                                        <span className='control-label '>
                                          <span className='adultstr infantOnlap'>
                                            {inputs.travelersinfLap !== 1
                                              ? 'Infants on Lap'
                                              : 'Infant on Lap'}
                                            <br />
                                            <span className='f11 traveler-msg_gray underTwoYrOld'>
                                              Under 2 years old
                                            </span>
                                          </span>
                                        </span>
                                        <div className='toggle is--textCenter is--right'>
                                          <span
                                            id='infantLapMobMinus'
                                            name='travelersinfLap'
                                            value={inputs.travelersinfLap}
                                            className={
                                              inputs.travelersinfLap <= 0
                                                ? 'is--left plus-minus--gray disable-btn minPax'
                                                : 'is--left plus-minus--gray disable-btn maxPax is--blue primaryBorder--color'
                                            }
                                            onClick={handleInputChange}
                                          >
                                            -
                                          </span>
                                          <span className='pasCount is--blue'>
                                            {inputs.travelersinfLap}
                                          </span>
                                          <span
                                            id='infantLapMobPlus'
                                            name='travelersinfLap'
                                            value={inputs.travelersinfLap}
                                            className='is--left plus-minus--gray disable-btn maxPax is--blue primaryBorder--color'
                                            onClick={
                                              handleInfantPassengerDetails
                                            }
                                          >
                                            +
                                          </span>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>

                                  <div className='row traveler-wrap--btnBody'>
                                    <button
                                      id='coachCabin'
                                      name='cabin'
                                      className={
                                        inputs.cabin === 'e'
                                          ? 'coach-button primaryBorder--color primaryBg--color-imp'
                                          : 'coach-button primaryBorder--color'
                                      }
                                      type='button'
                                      value='e'
                                      onClick={handleInputChange}
                                    >
                                      Economy
                                    </button>
                                    <button
                                      id='peCabin'
                                      name='cabin'
                                      className={
                                        inputs.cabin === 'b'
                                          ? 'coach-button primaryBorder--color primaryBg--color-imp'
                                          : 'coach-button primaryBorder--color'
                                      }
                                      type='button'
                                      value='b'
                                      onClick={handleInputChange}
                                    >
                                      Business
                                    </button>
                                    <button
                                      id='businessCabin'
                                      name='cabin'
                                      className={
                                        inputs.cabin === 'w'
                                          ? 'coach-button primaryBorder--color primaryBg--color-imp'
                                          : 'coach-button primaryBorder--color'
                                      }
                                      type='button'
                                      value='w'
                                      onClick={handleInputChange}
                                    >
                                      Premium Coach
                                    </button>
                                    <button
                                      id='firstCabin'
                                      name='cabin'
                                      className={
                                        inputs.cabin === 'f'
                                          ? 'coach-button primaryBorder--color primaryBg--color-imp'
                                          : 'coach-button primaryBorder--color'
                                      }
                                      type='button'
                                      value='f'
                                      onClick={handleInputChange}
                                    >
                                      First
                                    </button>
                                  </div>
                                </div>
                                <div className='travelerBtn-section row'>
                                  <div className='row travelernewDesign-error'>
                                    <div className='inline hidden'>
                                      <section>
                                        <div>
                                          <ul className='traveler-bottom'></ul>
                                        </div>
                                      </section>
                                    </div>
                                  </div>
                                  <button
                                    id='resetAllPassengers'
                                    className={
                                      inputs.cabin === 'e' &&
                                        inputs.travelers === 1 &&
                                        inputs.travelerssnr === 0 &&
                                        inputs.travelerschd === 0 &&
                                        inputs.travelersinf === 0 &&
                                        inputs.travelersinfSeat === 0 &&
                                        inputs.travelersinfLap === 0
                                        ? 'btn-reset disabledResetButton'
                                        : 'btn-reset'
                                    }
                                    onClick={handleInputChange}
                                    disabled={
                                      inputs.cabin === 'e' &&
                                        inputs.travelers === 1 &&
                                        inputs.travelerssnr === 0 &&
                                        inputs.travelerschd === 0 &&
                                        inputs.travelersinf === 0 &&
                                        inputs.travelersinfSeat === 0 &&
                                        inputs.travelersinfLap === 0
                                        ? 'disabled'
                                        : ''
                                    }
                                  >
                                    Clear All
                                  </button>
                                  <button
                                    className='donetraveler-btn btn-color'
                                    onClick={handleHide}
                                  >
                                    Confirm
                                  </button>
                                </div>
                              </div>
                            </div>
                          </section>
                        </main>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <form name='flights' id='flights' onSubmit={handleSubmit}>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 one_way'>
              <div className='wizard-container'>
                <div
                  className='card wizard-card one_way2'
                  data-color='red'
                  id='wizard'
                >
                  <div className='wizard-navigation '>
                    <ul className='nav nav-pills'>
                      <li
                        id='ow_trip'
                        className={!senCheckTrip ? 'active' : ''}
                        style={{ width: '50%' }}
                        onClick={() => setLastClickedDate('depart')}
                      >
                        <a
                          onClick={showOneWayForm}
                          data-toggle='tab'
                          data-act='One-Way'
                          aria-expanded={!senCheckTrip}
                        >
                          One Way
                        </a>
                      </li>
                      <li
                        id='rt_trip'
                        className={senCheckTrip == true ? 'active' : ''}
                        onClick={showRoundTripForm}
                        style={{ width: '50%' }}
                      >
                        <a

                          data-toggle='tab'
                          data-act='Round'
                          aria-expanded={senCheckTrip}
                        >
                          Round Trip
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className='tab-content'>
                    <div
                      className={isTripRound ? 'tab-pane' : 'tab-pane active'}
                      id='details'
                    >
                      <div className='date_s'>
                        <div className='form_start_main'>
                          <div
                            className='from_to'
                            onClick={e => openOriginDestPopup('origin', e)}
                          >
                            <div className='form_step_1'>
                              <img src={FromIcon} alt='' />
                            </div>
                            <div className='form_step_2'>
                              <div className='input-group'>
                                <div
                                  style={{ marginRight: '47px' }}
                                  className={`form-group ${errors?.origin && 'field-error-focus'
                                    }`}
                                >
                                  <label className='control-label'>
                                    {flightData.origin
                                      ? flightData.origin.split('-')[0]
                                      : 'From'}
                                  </label>
                                  <input
                                    name='name'
                                    value={
                                      flightData?.origin
                                        ? flightData.origin.split('-')[1].trim()
                                        : 'Enter City or Airport'
                                    }
                                    type='text'
                                    className='sourceAirport form-control'
                                    maxLength='80'
                                    readOnly={true}
                                  />
                                  {errors.origin && (
                                    <span>
                                      <span
                                        style={{
                                          position: 'absolute',
                                          top: '15px',
                                          right: '10px'
                                        }}
                                      >
                                        <img
                                          src={ErrorIcon}
                                          height='25px'
                                          alt=''
                                        />
                                      </span>
                                      <span className='field-error'>
                                        {errors.origin}
                                      </span>
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className='form_border_empty'>&nbsp;</div>
                            <div className='form_border_fill'></div>
                          </div>
                          <div
                            className='from_to'
                            onClick={e => openOriginDestPopup('destination', e)}
                          >
                            <div className='form_step_1'>
                              <img src={LocationIcon} alt='' />
                            </div>
                            <div className='form_step_2'>
                              <div className='input-group'>
                                <div
                                  style={{ marginRight: '47px' }}
                                  className={`form-group ${errors?.destination && 'field-error-focus'
                                    }`}
                                >
                                  <label className='control-label'>
                                    {flightData.destination
                                      ? flightData.destination
                                        .split('-')[0]
                                        .trim()
                                      : 'To'}
                                  </label>
                                  <input
                                    value={
                                      flightData.destination
                                        ? flightData.destination
                                          .split('-')[1]
                                          .trim()
                                        : 'Enter City or Airport'
                                    }
                                    name='name'
                                    type='text'
                                    className='destinationairport form-control'
                                    maxLength='80'
                                    readOnly={true}
                                  />
                                  {errors?.destination && (
                                    <span>
                                      <span
                                        style={{
                                          position: 'absolute',
                                          top: '15px',
                                          right: '10px'
                                        }}
                                      >
                                        <img
                                          src={ErrorIcon}
                                          height='25px'
                                          alt=''
                                        />
                                      </span>
                                      <span className='field-error'>
                                        {errors.destination}
                                      </span>
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className='form_border_empty'>&nbsp;</div>
                            <div className='form_border_fill form_border_fill_none'></div>
                          </div>
                          <div className='form_start_main2'>
                            <img
                              src={ExchangeIcon}
                              onClick={() => { exchangeDetails(); props.setExchangeData(true)
                                props.setStopExchangeApiRun(!props.stopExchangeApiRun) }}
                              alt=''
                            />
                          </div>
                        </div>
                      </div>

                      <div className='form_date_none'>
                        <div
                          className={clsx(
                            senCheckTrip
                              ? 'col-sm-6 date_mini_main'
                              : 'col-sm-12 date_s'
                          )}
                        >
                          <div className='date_start_main'>
                            <div
                              className='from_to'
                              onClick={() =>
                                openOriginDestPopup('datePickerDepart')
                              }
                            >
                              <div
                                className={clsx(
                                  senCheckTrip ? 'date_mini_icon' : 'form_step_1'
                                )}
                              >
                                <img src={CalendarIcon} alt='' height={20} width={20} />
                              </div>
                              <div
                                className={clsx(
                                  senCheckTrip ? 'date_mini_text' : 'form_step_2'
                                )}
                              >
                                <div className='input-group'>
                                  <div className='form-group'>
                                    <label className='control-label'>
                                      {!(flightData.depDate === '')
                                        ? format(flightData.depDate, 'MM/DD')
                                        : 'Depart'}
                                    </label>
                                    <input
                                      value={
                                        !(flightData.depDate === '')
                                          ? format(
                                            flightData.depDate,
                                            'ddd, MMM DD, YY'
                                          )
                                          : ''
                                      }
                                      name='name'
                                      type='text'
                                      className='form-control'
                                      readOnly={true}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {senCheckTrip && (
                          <div className='col-sm-6 date_mini_main2'>
                            <div className='date_start_main'>
                              <div
                                className='from_to'
                                onClick={() =>
                                  openOriginDestPopup('datePickerReturn')
                                }
                              >
                                <div className='date_mini_icon2'>
                                  <img src={CalendarIcon} alt='' />
                                </div>
                                <div className='date_mini_text2'>
                                  <div className='input-group'>
                                    <div className='form-group'>
                                      <label className='control-label'>
                                        {!(flightData.retDate === '')
                                          ? format(flightData.retDate, 'MM/DD')
                                          : 'Return'}
                                      </label>
                                      <input
                                        value={
                                          !(flightData.retDate === '')
                                            ? format(
                                              flightData.retDate,
                                              'ddd, MMM DD, YY'
                                            )
                                            : ''
                                        }
                                        name='name'
                                        type='text'
                                        className='form-control'
                                        readOnly={true}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className='form_date_none'>
                        <div className='col-sm-12 date_s'>
                          <div className='date_start_main'>
                            <div
                              className='from_to'
                              onClick={() => openOriginDestPopup('passenger')}
                            >
                              <div className='form_step_1'>
                                <img src={TravelerIcon} alt='' />
                              </div>
                              <div className='form_step_2 custom-select'>
                                <div className='input-group'>
                                  <div className='form-group'>
                                    <label className='control-label '>
                                      {passengersCount + inputs.travelersinfLap}
                                      <span className='traveler_m'>
                                        {passengerDetails}
                                      </span>
                                    </label>
                                    <input
                                      value=''
                                      name='name'
                                      type='text'
                                      className='form-control'
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='wizard-footer'>
            <div className='row'>
              <div className='col-md-12 btn_pad'>
                <div className='input-group btn_hundared'>
                  <button
                    type='submit'
                    className='btn btn-next btn-fill btn-danger btn_home'
                    id='fdimgbutton'
                    title='Search Flights'
                    disabled={isSubmitting}
                  >
                    <img src={SearchIcon} alt='' />
                    {!isSubmitting ? (
                      'Search Flights'
                    ) : (
                      <p className='loading' style={{ display: 'inline' }}>
                        Searching
                      </p>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export default FormOne
